module.exports = __webpack_public_path__ + "img/95.1d1005d5.jpg";